export default __webpack_public_path__ + "static/media/warning.746d4daf.svg";